import { render } from "./AccountDefinition.vue?vue&type=template&id=684cb67e"
import script from "./AccountDefinition.vue?vue&type=script&lang=js"
export * from "./AccountDefinition.vue?vue&type=script&lang=js"
script.render = render

export default script